import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "input", "clear"]
  static values = { 
    debounceDelay: { type: Number, default: 300 }
  }

  connect() {
    this.timeout = null
    this.toggleClearButton()
  }

  disconnect() {
    this.clearTimeout()
  }

  search() {
    // Clear existing timeout
    this.clearTimeout()
    
    // Update clear button visibility
    this.toggleClearButton()
    
    // Debounce the search
    this.timeout = setTimeout(() => {
      this.submitForm()
    }, this.debounceDelayValue)
  }

  clearSearch() {
    this.inputTarget.value = ""
    this.toggleClearButton()
    this.submitForm()
    this.inputTarget.focus()
  }

  submitForm() {
    if (this.hasFormTarget) {
      this.formTarget.requestSubmit()
    }
  }

  toggleClearButton() {
    if (this.hasClearTarget) {
      const hasValue = this.inputTarget.value.trim().length > 0
      this.clearTarget.style.display = hasValue ? 'block' : 'none'
    }
  }

  clearTimeout() {
    if (this.timeout) {
      clearTimeout(this.timeout)
      this.timeout = null
    }
  }

  // Handle keyboard shortcuts
  handleKeydown(event) {
    if (event.key === 'Escape') {
      this.clearSearch()
    }
  }
} 